export default "__VITE_ASSET__Bem0ajQE__"